export const sanitizeBoolean = (value?: string | boolean) => value === true || value === 'true';
